import { sendPrefetch } from '../../api'
import makeClient from '../../urql/client'
import { getCookie, setCookie } from '../../utils/cookies'
import STORE_CUSTOMER_MUTATION from '~/components/landing-form/store-customer-mutation.gql'
import env from '~/server/helpers/env'
import { QLJAddressFormat } from '~/utils/format-address'
import { isValidPostcode, formatPostcode, noAddressListed } from '~/utils/postcode'

import { addressApiUrl as addressApiUrls } from '~/../__config__/urls.json'

export const POSTCODE_STATE = 'postcode'
export const ADDRESS_STATE = 'address'
export const PROVIDER_STATE = 'provider'

const HTTP_OK = 200
const HTTP_BAD_REQUEST = 400
const HTTP_NOT_FOUND = 404

const ADDRESS_COOKIE_NAME = 'rvu-bb-personalised'
const ADDRESS_COOKIE_VALUE = 'property'
const DAYS_IN_ONE_YEAR = 365

export const validatePostcode = (input) => (isValidPostcode(formatPostcode(input)) ? ADDRESS_STATE : POSTCODE_STATE)

export const getAddresses = async (input) => {
  const postcode = formatPostcode(input)

  const addressUrl = addressApiUrls.addressLookup[env || 'production']
  const queryURL = `${addressUrl}?query=${encodeURIComponent(postcode)}`

  const response = await fetch(queryURL)

  if (response.status !== HTTP_OK) {
    const error = new Error(
      [HTTP_BAD_REQUEST, HTTP_NOT_FOUND].includes(response.status)
        ? 'addresses not found'
        : 'Non 200 HTTP status in response'
    )

    error.statusCode = response.status
    throw error
  }

  const data = await response.json()

  return data.concat(noAddressListed(postcode)).map((address) => QLJAddressFormat(address))
}

export const selectAddress = async (address, formId) => {
  sendPrefetch(address)
  const [client] = makeClient({ isServer: false, fetch, uscd: getCookie('uscd') })

  const mutationVariables = {
    customer: {
      address: QLJAddressFormat(address),
      formStartedId: formId
    }
  }

  const { data } = await client.mutation(STORE_CUSTOMER_MUTATION, mutationVariables).toPromise()

  if (data) {
    setCookie(ADDRESS_COOKIE_NAME, ADDRESS_COOKIE_VALUE, DAYS_IN_ONE_YEAR)
  }

  return PROVIDER_STATE
}

export default { validatePostcode, getAddresses, selectAddress }
